import { motion } from 'framer-motion';
import { VideoInput } from '@/components/video/video-input';

export function BottomCTA() {
  return (
    <section className="bg-gradient-to-b from-white to-indigo-50/30 py-24">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="mx-auto max-w-2xl text-center"
        >
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl">
            Ready to Transform Your Learning?
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Convert any educational video into comprehensive study materials
          </p>
          <div className="mt-8">
            <div className="relative rounded-xl bg-white/90 p-8 shadow-lg backdrop-blur-sm transition-all duration-300 hover:shadow-xl dark:bg-dark-card/90">
              <div className="absolute inset-0 -z-10 rounded-xl bg-gradient-to-r from-primary-100/20 via-transparent to-primary-100/20 opacity-80 blur-xl" />
              <VideoInput />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
} 